var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "login" } }, [
    _c("div", { staticClass: "login-card" }, [
      _c("div", { staticClass: "card-title" }, [
        _c("img", { attrs: { src: _vm.logo } }),
        _vm._v(" "),
        _c("h1", [_vm._v(_vm._s(_vm.$t("login.title")))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c(
          "form",
          {
            staticClass: "login",
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.login($event)
              }
            }
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.username,
                  expression: "username"
                }
              ],
              attrs: {
                id: "username",
                type: "text",
                placeholder: _vm.$t("login.username"),
                required: "",
                autofocus: ""
              },
              domProps: { value: _vm.username },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.username = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.password,
                  expression: "password"
                }
              ],
              attrs: {
                id: "password",
                type: "password",
                placeholder: _vm.$t("login.password"),
                required: ""
              },
              domProps: { value: _vm.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.password = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "level options is-mobile" }, [
              _c(
                "div",
                { staticClass: "checkbox level-left" },
                [
                  _c(
                    "b-checkbox",
                    {
                      model: {
                        value: _vm.rememberme,
                        callback: function($$v) {
                          _vm.rememberme = $$v
                        },
                        expression: "rememberme"
                      }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("login.rememberme")) +
                          "\n            "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "btn btn-link level-right",
                  on: {
                    click: function($event) {
                      return _vm.$store.dispatch("about", true)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("about")))]
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button is-rounded is-large is-fullwidth",
                attrs: { type: "submit" }
              },
              [_vm._v(_vm._s(_vm.$t("login.submit")))]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }